import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${API_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('splitpe_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('splitpe_token');
      localStorage.removeItem('splitpe_user');
      window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  requestOTP: (phoneNumber) => 
    api.post('/auth/request-otp', { phone_number: phoneNumber }),
  
  verifyOTP: (phoneNumber, otp) => 
    api.post('/auth/verify-otp', { phone_number: phoneNumber, otp }),
};

// Profile API
export const profileAPI = {
  get: () => api.get('/profile'),
  
  update: (data) => api.put('/profile', data),
};

// Expenses API
export const expensesAPI = {
  create: (data) => api.post('/expenses', data),
  
  list: (limit = 20, offset = 0) => 
    api.get(`/expenses?limit=${limit}&offset=${offset}`),
  
  get: (id) => api.get(`/expenses/${id}`),
  
  getUPILink: (id) => api.get(`/expenses/${id}/upi-link`),
  
  settle: (id, upiTransactionId = null) => 
    api.post(`/expenses/${id}/settle`, { upi_transaction_id: upiTransactionId }),
};

// Balance API
export const balanceAPI = {
  get: () => api.get('/balances'),
};

// Home API (combined data)
export const homeAPI = {
  get: () => api.get('/home'),
};

// Health check
export const healthAPI = {
  check: () => api.get('/health'),
};

// Groups API
export const groupsAPI = {
  list: () => api.get('/groups'),
  
  get: (groupId) => api.get(`/groups/${groupId}`),
  
  create: (data) => api.post('/groups', data),
  
  addMember: (groupId, phoneNumber) => 
    api.post(`/groups/${groupId}/members`, { phone_number: phoneNumber }),
  
  removeMember: (groupId, memberUserId) => 
    api.delete(`/groups/${groupId}/members/${memberUserId}`),
  
  createExpense: (groupId, data) => 
    api.post(`/groups/${groupId}/expenses`, data),
  
  getExpenses: (groupId) => 
    api.get(`/groups/${groupId}/expenses`),
};

export default api;
